<script setup lang="ts">
import type { PropertyPricesProps } from './types';

defineProps<{ isLoading: boolean }>();

const skeletonVariant = 'whiteHighlight';
</script>

<template>
	<div class="size-full space-y-8 bg-white-dark-2 px-4 py-5 md:p-8">
		<div class="space-y-8">
			<div class="space-y-3">
				<Skeleton
					:is-active="isLoading"
					class="h-[14px] w-[100px]"
					:variant="skeletonVariant"
				/>
				<Skeleton
					:is-active="isLoading"
					class="h-[26px] w-[178px]"
					:variant="skeletonVariant"
				/>
			</div>

			<div class="space-y-4">
				<div
					v-for="index in 3"
					:key="`property-prices-skeleton-${index}`"
					class="flex items-center justify-between"
				>
					<Skeleton
						:is-active="isLoading"
						class="h-3"
						:class="index % 2 ? 'w-[80px]' : 'w-[120px]'"
						:variant="skeletonVariant"
					/>
					<Skeleton
						:is-active="isLoading"
						class="h-3"
						:class="index % 2 ? 'w-[120px]' : 'w-[80px]'"
						:variant="skeletonVariant"
					/>
				</div>
			</div>

			<div class="flex items-center gap-4">
				<Skeleton
					:is-active="isLoading"
					class="size-12 rounded-full"
					:variant="skeletonVariant"
				/>
				<div class="space-y-4">
					<Skeleton
						:is-active="isLoading"
						class="h-4 w-[108px]"
						:variant="skeletonVariant"
					/><Skeleton
						:is-active="isLoading"
						class="h-3 w-[192px]"
						:variant="skeletonVariant"
					/>
				</div>
			</div>

			<Skeleton
				:is-active="isLoading"
				class="h-12 w-full"
				:variant="skeletonVariant"
			/>
		</div>
	</div>
</template>
